import { API_PREFIX } from "./api.constants";

export const COURSE_ENDPOINTS = {
  COURSES: `${API_PREFIX}/courses`,
  COURSE_DETAIL: (courseId: number | string) =>
    `${API_PREFIX}/courses/${courseId}`,
  COURSES_EXPORT: `${API_PREFIX}/courses/export`,
  COURSE_CUSTOM_FIELD_DEFINITIONS: `${API_PREFIX}/courses/cfn/`,
  COURSE_CUSTOM_FIELD_DEFINITION_DETAIL: (definitionId: number | string) =>
    `${API_PREFIX}/courses/cfn/${definitionId}`,
  CHECK_COMPLETION: (courseId: number | string) =>
    `${API_PREFIX}/courses/${courseId}/check-completion`,
  MY_CERTIFICATE: (courseId: number | string) =>
    `${API_PREFIX}/courses/${courseId}/my-certificate`,
  RATE_COURSE: (courseId: number | string) => `${API_PREFIX}/courses/${courseId}/rate`,
  GET_RATINGS: (courseId: number | string) => `${API_PREFIX}/courses/${courseId}/ratings`,
  DELETE_RATING: (courseId: number | string, ratingId: number | string) =>
    `${API_PREFIX}/courses/${courseId}/ratings/${ratingId}`,
  GROUPS: (courseId: number | string) => `${API_PREFIX}/courses/${courseId}/groups`,
  GROUP_DETAIL: (courseId: number | string, groupId: number | string) =>
    `${API_PREFIX}/courses/${courseId}/groups/${groupId}`,
  GROUP_MEMBERS: (courseId: number | string, groupId: number | string) =>
    `${API_PREFIX}/courses/${courseId}/groups/${groupId}/members`,
  GROUP_ADDABLE_USERS: (courseId: number | string, groupId: number | string) =>
    `${API_PREFIX}/courses/${courseId}/groups/${groupId}/addable-users`,
  PREREQUISITES: (courseId: number | string) =>
    `${API_PREFIX}/courses/${courseId}/prerequisites`,
  PREREQUISITE_CANDIDATES: (courseId: number | string) =>
    `${API_PREFIX}/courses/${courseId}/prerequisite-candidates`,
  ROLE_ASSIGNMENTS: (courseId: number | string) =>
    `${API_PREFIX}/courses/${courseId}/role-assignments`,
  ROLE_ASSIGNMENT_DETAIL: (courseId: number | string, assignmentId: number | string) =>
    `${API_PREFIX}/courses/${courseId}/role-assignments/${assignmentId}`,
  ASSIGNABLE_ROLES: (courseId: number | string) =>
    `${API_PREFIX}/courses/${courseId}/assignable-roles`,
  COMPLETION_SETTINGS: (courseId: number | string) =>
    `${API_PREFIX}/courses/${courseId}/completion-settings`,
  MY_COMPLETION: (courseId: number | string) =>
    `${API_PREFIX}/courses/${courseId}/my-completion`,
  COURSE_DETAILS_FOR_USER: (courseId: number | string) =>
    `${API_PREFIX}/courses/${courseId}/details-for-user`,
  COURSE_RECYCLE_BIN: `${API_PREFIX}/courses/recycle-bin`,
  COURSE_RESTORE: (courseId: number | string) => `${API_PREFIX}/courses/${courseId}/restore`,
  COURSE_PURGE: (courseId: number | string) => `${API_PREFIX}/courses/${courseId}/purge`,
  COURSE_REPORT_OVERVIEW: (courseId: number | string) =>
    `${API_PREFIX}/courses/${courseId}/report/overview`,
  COURSE_REPORT_HEATMAP: (courseId: number | string) =>
    `${API_PREFIX}/courses/${courseId}/report/heatmap`,
  COURSE_MY_HISTORY: (courseId: number | string) =>
    `${API_PREFIX}/courses/${courseId}/my-completion-history`,
  COURSE_LOGS: (courseId: number | string) =>
    `${API_PREFIX}/courses/${courseId}/logs`,
  COURSE_REPORT_GRADES: (courseId: number | string) =>
    `${API_PREFIX}/courses/${courseId}/report/grades`,
  COURSE_REPORT_ACTIVITY: (courseId: number | string, activityId: number | string) =>
    `${API_PREFIX}/courses/${courseId}/report/activity/${activityId}`,
  COURSE_REPORT_ACTIVITY_EXPORT: (courseId: number | string, activityId: number | string) =>
    `${API_PREFIX}/courses/${courseId}/report/activity/${activityId}/export`,
  COURSE_REPORT_AUDIENCE: (courseId: number | string) =>
    `${API_PREFIX}/courses/${courseId}/report/audience`,
  COURSE_REPORT_EMAIL: (courseId: number | string) =>
    `${API_PREFIX}/courses/${courseId}/report/email`,
  COURSE_REPORT_QUESTION_ACTIVITIES: (courseId: number | string) =>
    `${API_PREFIX}/courses/${courseId}/report/question-activities`,
  COURSE_REPORT_QUESTION_STATS: (courseId: number | string) =>
    `${API_PREFIX}/courses/${courseId}/report/question-stats`,
  COURSE_ENGAGEMENT: (courseId: number | string) =>
    `${API_PREFIX}/courses/${courseId}/engagement`,
  SIMILAR_COURSES: (courseId: number | string) =>
    `${API_PREFIX}/courses/courses/${courseId}/similar`,
};

export const CATEGORY_ENDPOINTS = {
  CATEGORIES: `${API_PREFIX}/course-categories`,
  CATEGORY_DETAIL: (categoryId: number | string) => `${API_PREFIX}/course-categories/${categoryId}`,
  CATEGORIES_TREE: `${API_PREFIX}/course-categories/tree`,
  CATEGORIES_TREE_WITH_COURSES: `${API_PREFIX}/course-categories/tree-with-courses`,
  CATEGORIES_EXPORT: `${API_PREFIX}/course-categories/export`,
  CATEGORY_MOVE: (categoryId: number | string) => `${API_PREFIX}/course-categories/${categoryId}/move`,
  CATEGORY_ROLE_ASSIGNMENTS: (categoryId: number | string) => `${API_PREFIX}/course-categories/${categoryId}/role-assignments`,
  CATEGORY_ROLE_ASSIGNMENT_DETAIL: (categoryId: number | string, assignmentId: number | string) =>
    `${API_PREFIX}/course-categories/${categoryId}/role-assignments/${assignmentId}`,
  COURSE_MOVE: (courseId: number | string) => `${API_PREFIX}/courses/${courseId}/move`,
  COURSE_QUICK_ASSIGN: (courseId: number | string) => `${API_PREFIX}/courses/${courseId}/quick-assign`,
};

export const CATALOG_ENDPOINTS = {
  SEARCH: `${API_PREFIX}/courses/catalog/search`,
  COUNTS: `${API_PREFIX}/courses/catalog/counts`,
};

export const BLOCK_ENDPOINTS = {
  GET_BLOCK: (blockId: number | string) =>
    `${API_PREFIX}/course-content/blocks/${blockId}`,
};

export const GRADEBOOK_ENDPOINTS = {
  SETTINGS: (courseId: number | string) =>
    `${API_PREFIX}/courses/${courseId}/gradebook/settings`,
  ITEMS: (courseId: number | string) =>
    `${API_PREFIX}/courses/${courseId}/gradebook/items`,
  RECALC: (courseId: number | string) =>
    `${API_PREFIX}/courses/${courseId}/gradebook/recalc`,
  USER_GRADES: (courseId: number | string) =>
    `${API_PREFIX}/courses/${courseId}/gradebook/users`,
  USER_GRADE_DETAIL: (courseId: number | string, userId: number | string) =>
    `${API_PREFIX}/courses/${courseId}/gradebook/users/${userId}`,
};